import { InjectionToken } from '@angular/core';

export type ColorScheme = 'light' | 'dark' | 'system';
export type TextSize = 'normal' | 'large';
export type Density = 'normal' | 'simplified';

export interface ThemeConfig {
  /** Initial colour scheme. `system` follows `prefers-color-scheme`. Default `light`. */
  scheme: ColorScheme;
  /** Stor-skrift-modus. Default `normal`. */
  textSize: TextSize;
  /** Forenklet modus. Default `normal`. */
  density: Density;
  /** Persist user choices to localStorage under this key. `false` disables. Default `'nb-theme'`. */
  storageKey: string | false;
}

export const NB_THEME_CONFIG = new InjectionToken<Partial<ThemeConfig>>('NB_THEME_CONFIG');

export const DEFAULT_THEME_CONFIG: ThemeConfig = {
  scheme: 'light',
  textSize: 'normal',
  density: 'normal',
  storageKey: 'nb-theme',
};
